/**
 * Creates DOM Element according to markup
 * @param {string} markup.
 * @return {Node} new element.
 */
export const createFromMarkup = (markup = '') => {
  const newElement = document.createElement('template');
  newElement.innerHTML = markup.trim();
  return newElement.content.firstChild;
};

/**
 * Debouncing (wait before running function)
 * @param {function} callback.
 * @param {number} wait Wait time in ms
 * @return {function}
 */
export const debounce = (callback, wait) => {
  let timeout;
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
};
